import React from "react";
import { TitleHeading } from "../typography/TitleHeading";
import BodyText from "../typography/BodyText";
import { HeroCta } from "./HeroCta";
import SideImage from "../layout/SideImage";
import Section from "../layout/Section";
import { Theme } from "../../hooks/useTheme";

interface TextCtaProps {
  tag: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  cta?: React.ReactNode;
  theme?: Theme;
  noMargin?: "no-margin" | "top" | "bottom";
}

const TextCta: React.FunctionComponent<TextCtaProps> = ({
  tag,
  title,
  description,
  theme = "dark",
  cta = <HeroCta theme={theme} />,
  noMargin,
}) => {
  return (
    <Section theme={theme} noMargin={noMargin}>
      <div className="flex flex-col max-w-4xl items-center mx-auto">
        <TitleHeading center theme={theme} tag={tag} title={title} />
        {description ? (
          <BodyText
            center
            dark={theme === "dark" || theme === "indigo"}
            justify={false}
            className="mt-2"
            mb={8}
          >
            {description}
          </BodyText>
        ) : (
          <div className="h-8" />
        )}
        {cta}
      </div>
    </Section>
  );
};

export default TextCta;
